import heatmapActionTypes from '../actionTypes/heatmap.actionTypes'
import { ActionType } from './common.reducer'
import {
    HeatmapConfiguration,
    HeatmapSecuritiesResponse,
    HeatmapGroupBy,
} from '../proto/generated/screener'

interface HeatmapStateType {
    config: HeatmapConfiguration | null
    data: HeatmapSecuritiesResponse | null
    loading: boolean
    configLoading: boolean
    error: string | null
    selectedIndex: string       // API value e.g. "NIFTY50", "" = no index filter
    selectedSector: string | null
    groupBy: HeatmapGroupBy
    sizeBy: string
    colorBy: string
}

const initialState: HeatmapStateType = {
    config: null,
    data: null,
    loading: false,
    configLoading: false,
    error: null,
    selectedIndex: '',
    selectedSector: null,
    groupBy: HeatmapGroupBy.SECTOR,
    sizeBy: 'marketCap',
    colorBy: 'change|1D',
}

export default function heatmapReducer(
    state: HeatmapStateType = initialState,
    action: ActionType
): HeatmapStateType {
    const { type, payload } = action

    switch (type) {
        case heatmapActionTypes.SET_CONFIG:
            return {
                ...state,
                config: payload,
                configLoading: false,
                selectedIndex: state.selectedIndex || payload?.defaultIndex || '',
                sizeBy: state.sizeBy !== 'marketCap' ? state.sizeBy : (payload?.defaultSizeBy || 'marketCap'),
                colorBy: state.colorBy !== 'change|1D' ? state.colorBy : (payload?.defaultColorBy || 'change|1D'),
            }
        case heatmapActionTypes.SET_DATA:
            return { ...state, data: payload, loading: false, error: null }
        case heatmapActionTypes.SET_LOADING:
            return { ...state, loading: payload }
        case heatmapActionTypes.SET_CONFIG_LOADING:
            return { ...state, configLoading: payload }
        case heatmapActionTypes.SET_ERROR:
            return { ...state, error: payload, loading: false, configLoading: false }
        case heatmapActionTypes.SET_INDEX:
            return {
                ...state,
                selectedIndex: payload,
                selectedSector: null,
                groupBy: HeatmapGroupBy.SECTOR,
            }
        case heatmapActionTypes.SET_SECTOR:
            return {
                ...state,
                selectedSector: payload,
                groupBy: payload ? HeatmapGroupBy.NO_GROUP : HeatmapGroupBy.SECTOR,
            }
        case heatmapActionTypes.SET_GROUP_BY:
            return { ...state, groupBy: payload }
        case heatmapActionTypes.SET_SIZE_BY:
            return { ...state, sizeBy: payload }
        case heatmapActionTypes.SET_COLOR_BY:
            return { ...state, colorBy: payload }
        default:
            return state
    }
}

export type { HeatmapStateType }
